/** Single source for the help overlay and the hints shown in buttons. */
export const SHORTCUTS: Array<{ group: string; items: Array<[string, string]> }> = [
  { group: 'Anywhere', items: [
    ['Ctrl K', 'Command palette: jump to a page, find a product, run an action'],
    ['Alt 1 … 0', 'Home · Billing · Inventory · Reports · Settings · Receive · Transactions · Stock take · Offers · Staff'],
    ['Alt C  /  Alt D', 'Customers & khata  /  Day close'],
    ['Alt P  /  Alt S', 'Purchase orders  /  Suppliers'],
    ['Alt F  /  Alt T', 'Fresh & bakery  /  Transfers between stores'],
    ['Ctrl L', 'Lock the till / switch cashier (when PINs are set)'],
    ['?', 'Show these shortcuts'],
    ['Esc', 'Close a sheet or clear the search'],
  ] },
  { group: 'Billing', items: [
    ['F1  or  /', 'Focus search / scanner field'],
    ['3*milk', 'Type a quantity then * to add that many (works with barcodes too)'],
    ['↑ ↓  Enter', 'Pick a search result and add it'],
    ['Alt ↑ ↓', 'Select a line in the bill'],
    ['+  −', 'Change quantity of the selected line (when search is empty)'],
    ['F2', 'Type quantity / weight for the selected line'],
    ['F3', 'Discount on the selected line'],
    ['F4', 'Customer mobile number'],
    ['F7', 'Change the price of the selected line (manager PIN if not allowed)'],
    ['F6', 'Discount on the whole bill'],
    ['Del', 'Remove the selected line'],
    ['F8  /  Shift F8', 'Hold bill / recall a held bill'],
    ['F9', 'Reprint the last bill'],
    ['F10  or  Ctrl Enter', 'Pay'],
  ] },
  { group: 'Payment', items: [
    ['F5  F6  F7  F8', 'Cash · UPI · Card · Credit'],
    ['type digits', 'Cash received (field is focused)'],
    ['Enter', 'Complete and print'],
    ['Ctrl Enter', 'Complete without printing'],
  ] },
  { group: 'Inventory', items: [
    ['/', 'Search products'],
    ['N', 'New product'],
    ['↑ ↓  Enter', 'Select and edit a product'],
    ['A', 'Adjust stock of the selected product'],
    ['I', 'Import products from CSV'],
    ['L', 'Print price / barcode labels for the selected product'],
  ] },
];
